import React from 'react';
import { IGaugePanel } from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import { StorePanelProps } from './StorePanel';
import GaugePanel from '../../../../../../../../theme/ui/Dashboard/GaugePanel/GaugePanel';
import { MultiStoreIcon } from '../../../../../../../../assets/dashboard';
import { useTranslation } from 'react-i18next';
import { CommanderAPI } from '../../../../../../../../service/device/CommanderAPI/CommanderAPI';
import { Alert } from '@mui/material';
import { skipToken } from '@reduxjs/toolkit/query';

function StoreWorkspacePanel(props: StorePanelProps) {
  const { panel, layout } = props;
  const { workspaceId } = panel;
  const {
    isFetching,
    currentData,
    error: errorDevicesConnectionStatus,
  } = CommanderAPI.useGetDevicesConnectionStatusCountByWorkspaceQuery(
    workspaceId ?? skipToken
  );
  const [t] = useTranslation();

  const gaugePanel: IGaugePanel = {
    ...panel,
    type: 'GAUGE',
    gaugeProps: {
      value: currentData?.mqttConnected ?? 0,
      valueMax: currentData ? currentData.count : 0,
    },
    loading: isFetching,
    icon: <MultiStoreIcon height={'100%'} />,
    labelValueActive: t('dashboard.stores.online'),
    labelValueInactive: t('dashboard.stores.offline'),
  };
  if (errorDevicesConnectionStatus)
    return <Alert severity="error">{t('dashboard.error.fetching')}</Alert>;
  return <GaugePanel panel={gaugePanel} layout={layout} />;
}

export default StoreWorkspacePanel;
